import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import { IConfig } from './types';
import { DevelopmentStyles } from './styles/DevelopmentStyles';

import { HappyEyesCheck } from './HappyEyesCheck';

const init = (selector: string, config: IConfig = {}) => {
    ReactDOM.render(
        <HappyEyesCheck config={config} />,
        document.getElementById(selector)
    );
};

const initWithDevelopmentStyles = (config: IConfig = {}) => {
    ReactDOM.render(
        <>
            <HappyEyesCheck config={config} />
            <DevelopmentStyles />
        </>,
        document.getElementById('pnlHappyEyesCheck')
    );
};

export { init, initWithDevelopmentStyles };
